import { Button } from "@devhop/ui";
import { CalendarDays } from "lucide-react";
import { RichTextOrPlain } from "@/shared/ui/RichTextOrPlain";

type CalendarAgendaRowProps = {
  title: string;
  kindLabel: string;
  whenLabel: string;
  onFocusCalendar?: () => void;
};

export function CalendarAgendaRow({
  title,
  kindLabel,
  whenLabel,
  onFocusCalendar,
}: CalendarAgendaRowProps) {
  return (
    <div className="grid items-center gap-3 py-4 md:grid-cols-[1fr_140px_1fr_80px]">
      <div className="min-w-0 font-medium">
        <RichTextOrPlain text={title} />
      </div>
      <div>
        <p className="text-[10px] text-muted-foreground uppercase">ປະເພດ</p>
        <p className="text-sm">{kindLabel}</p>
      </div>
      <div>
        <p className="text-[10px] text-muted-foreground uppercase">
          ວັນທີ / ເວລາ
        </p>
        <p className="text-sm">{whenLabel}</p>
      </div>
      <div className="flex justify-end">
        {onFocusCalendar ? (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="size-9"
            onClick={onFocusCalendar}
            title="ເບິ່ງໃນປະຕິທິນ"
          >
            <CalendarDays className="size-4" />
          </Button>
        ) : (
          <span className="text-muted-foreground text-xs">—</span>
        )}
      </div>
    </div>
  );
}
